export const FONT_ARIAL_TOKEN = "{font.Arial}";
